// removed by extract-text-webpack-plugin
module.exports = {"ArticleTags":"_1O-_N2IoegFPvkMtqanCqr","IEWrapper":"_3esJCc2exfz_FFsW9rdc56","iconWrapper":"_2PhYgKI-lrrFRJ9yJVgZDI","icon":"_2ZMcs206IDgkfdhxyV9cAz","tags":"_2sOb7tkfBHbwgxTw9TykQ8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ArticleTags/ArticleTags.module.scss
// module id = 732
// module chunks = 0